"use client";

import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Check } from "lucide-react";
const GoldCheck = () => <div className="mr-3 flex items-center justify-center rounded-full size-6 flex-shrink-0" style={{
  backgroundColor: "#C49A3C"
}}>
    <Check size={14} color="white" strokeWidth={3} />
  </div>;
function CategoriesListConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <ul className="space-y-2">
        {[...Array(3)].map((_, i) => <li key={i} data-index={i} className="h-5 w-48 rounded bg-muted/30 animate-pulse" />)}
      </ul>;
  }
  if (error || terms.length === 0) {
    return <ul className="space-y-2 text-foreground">
        {["Luxury tiles", "Premium sanitary ware", "Architectural surfaces"].map((item, i) => <li key={i} className="flex items-center">
            <GoldCheck />
            <span>{item}</span>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-2 text-foreground">
      {terms.map((term, i) => <li key={term.id} data-index={i} className="flex items-center">
          <GoldCheck />
          <span>{term.name}</span>
        </li>)}
    </ul>;
}
export default function ShowroomExperienceContent() {
  return <section id="showroomexperiencecontent" className="!bg-[hsl(33,21%,81%)] ![padding:96px_0px_96px_0px]">
      <div className="container mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-20 items-center">
          {}
          <div className="flex flex-col space-y-6">
            <h2 className="font-display font-bold text-foreground leading-tight !text-5xl">Premium Showroom Experience</h2>
            <p className="font-sans text-foreground leading-relaxed">
              Our showroom offers a curated selection of high-quality tiles and sanitary ware, allowing clients to experience materials firsthand before making decisions.
            </p>
            <div className="space-y-3">
              <p className="font-sans text-base font-medium text-foreground">
                Product categories include:
              </p>
              <EcommerceTermsProvider taxonomy="product_cat" wp_term_query={{
              per_page: 10,
              orderby: "name",
              order: "asc"
            }} term_fields={["id", "name", "slug"]}>
                <CategoriesListConsumer />
              </EcommerceTermsProvider>
            </div>
            <p className="font-sans text-foreground leading-relaxed">
              We collaborate exclusively with trusted international brands to ensure durability, performance, and visual excellence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90 px-6 py-3 font-sans font-semibold shadow-xs transition-all">
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full bg-background border-border text-foreground hover:bg-accent hover:text-accent-foreground px-6 py-3 font-sans font-semibold shadow-xs transition-all">
              </Button>
            </div>
          </div>
          {}
          <div className="relative">
            <img src="https://theksway.com/wp-content/uploads/2026/04/PXL_20260402_141120928.jpg" alt="Premium showroom interior with tile and sanitary ware displays" className="w-full h-auto rounded-lg md:rounded-xl object-cover shadow-md" />
          </div>
        </div>
      </div>
    </section>;
}